/* eslint-disable no-undef */

function initBaseUrl() {
  const { protocol, hostname, port } = window.location;
  return `${protocol}//${hostname}${port ? `:${port}` : ''}`;
}

function initApiHost() {
  const scheme = isProduction ? 'https' : 'http';
  const name = isProduction ? productionApiDomain : devApiHost;
  const port = isProduction ? '443' : devApiPort;
  const baseUrl = isProduction
    ? `${scheme}://${name}`
    : `${scheme}://${name}:${port}`;

  return {
    name,
    port,
    scheme,
    baseUrl,
  };
}

const productionBaseDomain = 'menur.app';
const productionApiDomain =
  process.env.REACT_APP_API_HOST || `api.${productionBaseDomain}`;
const devApiHost = 'localhost';
const devApiPort = '8080';
const isProduction = process.env.NODE_ENV === 'production';

// const isProduction = true;
const apiHost = initApiHost();
const baseUrl = initBaseUrl();
const subdomain = window.location.host.split('.')[0];
console.log('subdomain', subdomain);

// const isDelivery = ['delivery'].includes(subdomain);
const isDelivery = ['delivery', 'zycmacbook'].includes(subdomain);

const isDevEnv = !isProduction;

export { apiHost, baseUrl, isDelivery, isDevEnv };
